(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["geethas-navaratri-banner"] && !Shopify.designMode) return;
  try {
    
  class GeethasNavaratriBanner extends HTMLElement {
    #timer;
    #abortController;

    connectedCallback() {
      this.#abortController = new AbortController();
      const options = { signal: this.#abortController.signal };
      document.addEventListener('visibilitychange', this.#refresh, options);
      window.addEventListener('pageshow', this.#refresh, options);
      this.#refresh();
    }

    disconnectedCallback() {
      clearTimeout(this.#timer);
      this.#abortController?.abort();
    }

    #refresh = () => {
      clearTimeout(this.#timer);
      const remaining = Date.parse(this.dataset.endsAt) - Date.now();
      if (!Number.isFinite(remaining) || remaining <= 0) {
        this.hidden = true;
        return;
      }
      this.#timer = setTimeout(this.#refresh, Math.min(remaining, 2147483647));
    };
  }

  if (!customElements.get('geethas-navaratri-banner')) {
    customElements.define('geethas-navaratri-banner', GeethasNavaratriBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
